export enum ToggleColor {
	ON_GOING = "ON_GOING",
	ONCE = "ONCE",
}
